module.exports = __webpack_public_path__ + "static/Downfall-aeceddc2f8589c80f848e717ad9e789f.png";